import { Box, styled } from '@mui/material'

const MainTabsWrapper = styled(Box)(() => ({
  borderRadius: '15px 15px 0px 0px',
  width: '100%',
  background: 'transparent',
}))

export default MainTabsWrapper
